import React, { FunctionComponent } from "react";
import { List, ListItem, Tooltip, Typography } from "@mui/material";
import { formatDateHyphen } from "../../../utils/time";
import { Log } from "../types";

interface LogWithVersion {
    id: number;
    date: string;
    version: number;
}

export const ChangeLogList: FunctionComponent<{ items: Log[], onSelect: (id: number) => void; }> = (props): JSX.Element => {
    const logs: Log[] = props.items;

    const logCounts = new Map<string, number>();

    const logsWithVersion: LogWithVersion[] = logs.map((log) => {
        const date = formatDateHyphen(new Date(log.text));
        const count = logCounts.get(date) || 0;
        logCounts.set(date, count + 1);
        return {
            id: log.id,
            date,
            version: count + 1,
        };
    });

    return (
        <List sx={{ display: "flex", flexDirection: "column", listStyle: "none", paddingLeft: "10px", width: 300, height: 200, border: "2px solid #F1F2F4", overflowY: "auto" }}>
            {
                logsWithVersion.map((item, index) => {
                    const { id, date, version } = item;
                    return (
                        <ListItem onClick={() => props.onSelect(id)} key={index} disablePadding>
                            <Typography sx={{ cursor: "pointer", display: "block", fontFamily: "Lato", fontWeight: "600", color: "#1BA0E9", borderLeft: "3px solid #1BA0E9", paddingLeft: "10px", height: "30px", "::before": { content: '""', width: "12px", height: "12px", display: "inline-block", backgroundColor: "#1BA0E9", borderRadius: 6, position: "relative", marginLeft: "-17px", marginRight: "10px", marginTop: "3px" } }}>
                                {
                                    `${date} (${version})`
                                }
                            </Typography>
                        </ListItem>
                    )
                })
            }
        </List>
    )
}